import { FormInstance } from "antd";
import { FC } from "react";
import OrganizationSelectionSetting from "../OrganizationSelectionSetting";
type PropsType = {
  form: FormInstance;
  getFieldClassName?: (name: string) => string;
};

const DivisionSelectionSetting: FC<PropsType> = ({
  form,
  getFieldClassName,
}) => {
  return (
    <OrganizationSelectionSetting
      form={form}
      modelName="division"
      getFieldClassName={getFieldClassName}
    />
  );
};

export default DivisionSelectionSetting;
